<template>
  <div id="v-fields-usuarios">
    <v-layout row wrap>
      <v-flex xs6>
        <MdText
          :disabled="gridConfig.isDeleteModal"
          ref="title"
          :validation="['required']"
          name="title"
          label="Título"
          v-model="gridConfig.editedItem.title"
        ></MdText>
      </v-flex>
      <v-flex xs2>
        <MdText
          :disabled="gridConfig.isDeleteModal"
          ref="width"
          :validation="['required']"
          name="width"
          label="Largura"
          v-model="gridConfig.editedItem.width"
        ></MdText>
      </v-flex>
      <v-flex xs2>
        <MdText
          :disabled="gridConfig.isDeleteModal"
          ref="height"
          :validation="['required']"
          name="height"
          label="Altura"
          v-model="gridConfig.editedItem.height"
        ></MdText>
      </v-flex>
      <v-flex xs12>
        <MdText
          :disabled="gridConfig.isDeleteModal"
          ref="src"
          :validation="['required']"
          name="src"
          label="Link"
          v-model="gridConfig.editedItem.src"
        />
      </v-flex>
      <v-flex xs4>
        <MdSwitch
          v-model="gridConfig.editedItem.allow_full_screen"
          trueValue="true"
          falseValue="false"
          label="Tela cheia"
          name="allow_full_screen"
          :disabled="gridConfig.isDeleteModal"
        ></MdSwitch>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
export default {
  name: "v-fields-indicadores",

  props: {
    gridConfig: {},

    exclusao: {
      type: Boolean,
    },
  },

  data() {
    return {};
  },

  created() {},

  methods: {
  },
};
</script>

<style>
</style>
